<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mgfLVc/tc-custom/9781848323421.jpg?1706098020469" alt="This image is the cover for the book Blockade"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blockade
      </h1>
      <p class="bookDescription body article font2">
        <b>This WWI naval history vividly tells the story of the Royal Navy’s Northern Blockade and the battles at sea that brought Germany to its knees.</b><br/><br/> At the outbreak of World War I, Britain established a naval blockade that greatly diminished Germany’s access to trade and vital resources. The Northern Blockade brought the German economy to its knees and greatly diminished home front morale. Patrolling the inhospitable waters between Iceland and Scotland, the 10th Cruiser Squadron played a vital role in winning the war on the Western Front. At the same time, the Royal Navy successfully countered Germany’s attacks on British commerce, preventing much suffering in Britain.<br/><br/> Drawing on numerous first-hand accounts, Historian Steve Dunn vividly chronicles this long-running battle at sea. Beginning with the blockade’s initial formation, he recounts the changes in strategy on both sides, including the use of converted liners and armed merchant vessels as warships. He also vividly describes the final destruction of German surface vessel commerce warfare, culminating in the hard-fought battle between the raider SMS <i>Leopard </i>and two British warships.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steve R Dunn
      </h2>
      
      <p class="authorDescription body article">STEVE DUNN has a special interest in the Royal Navy of the late Victorian, Edwardian and First World War eras. His books include biographies of Admirals Cradock (The Scapegoat) and Troubridge (The Coward?) and the story of the first British battleship, Formidable, to be sunk by a torpedo. He lives in Worcestershire and southwest France.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Seaforth Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43768de5